<template>
  <div class="accountSwapperWrapper" :class="{ noBand: !HAS_BAND }">
    <div class="paddedWrapper background">
      <div class="headerWrapper">
        <div class="head background" @click.stop="$emit('close')">
          <i class="fas fa-chevron-left" />
          <span class="title">{{ $t("layout.menu.menu04") }}</span>
        </div>
      </div>
      <account_display
        v-for="account in accounts"
        :key="account.pk"
        class="background"
        :account="account"
      />
    </div>
    <div class="foot">
      <hollow_main_btn @click="login_request_account_swap">
        <div class="btnText">
          {{ $t("auth.accountSwitch00") }}
        </div>
      </hollow_main_btn>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex"

import account_display from "./accountSwapper/accountDisplay"
import hollow_main_btn from "~/components/shared/hollowMainBtn"

export default {
  components: {
    hollow_main_btn,
    account_display,
  },
  computed: {
    ...mapState({
      accounts: (state) => state.accounts,
      HAS_BAND: (state) => state.user.band.id,
    }),
  },
  methods: {
    ...mapActions({
      login_request_account_swap: "login/REQUEST_ACCOUNT_SWAP",
    }),
  },
}
</script>

<style scoped src="./accountSwapper.css"></style>
